<template>
  <div
    :class="['nd-drag',{close: !open}, `caseId-${kingGoodsCd}`]"
    data-sensors-click
    ref="dragDom"
    @click="jumpToKingCardPage"
    data-sensors-exposure-event-name="Element_Exposure"  data-sensors-exposure-property-caseId="SKC_M"
  >
    <div class="title">{{kingFloatTitle||'插队申请'}}</div>
    <div class="skc-lottie">
      <vue-lottie :options="lottieOptions" ></vue-lottie>
    </div>
     
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getKey } from '../../assets/utils'
import VueLottie from 'vue-lottie'
import king from './king.json'

export default {
  props: ['kingGoodsCd', 'kingFloatTitle'],
  data () {
    return {
      lottieOptions: {
        animationData: king,
        loop: true
      },
      isDragged: false,
      domLeft: 0,
      domTop: 0,
      initX: 0,
      initY: 0,
      open: true,
      hideShow: false,
      topPosition: 0 // 页面顶部的限制距离
    }
  },
  components: {
    VueLottie
  },
  computed: {
    ...mapState({
      statusBarHeight: (state) => state.statusBarHeight || 0
    }),
    title () {
      const { title } = getKey('userInfo')
      return title
    }
  },
  mounted () {
    const dragDom = this.$refs.dragDom
    if (!dragDom) return
    // 页面宽度和高度
    const pageWidth = document.documentElement.clientWidth
    let pageHeight = document.documentElement.clientHeight
    // 拖拽元素宽度和高度
    const dragWidth = dragDom.offsetWidth
    const dragHeight = dragDom.offsetHeight

    // 初始化位置信息
    const dragPosition = JSON.parse(
      sessionStorage.getItem('dragPosition') || 'null'
    )
    if (dragPosition) {
      dragDom.style.top = dragPosition.top
    } else {
      dragDom.style.top = pageHeight - dragHeight - 100 + 'px'
    }

    dragDom.addEventListener('touchstart', (e) => {
      e.stopPropagation()
      this.isDragged = true
      this.initX = e.touches[0].clientX
      this.initY = e.touches[0].clientY
      this.domLeft = dragDom.offsetLeft
      this.domTop = dragDom.offsetTop
    })
    dragDom.addEventListener('touchmove', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (this.isDragged) {
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        // 鼠标移动的距离
        const offsetX = x - this.initX
        const offsetY = y - this.initY
        // 鼠标移动后元素的新位置
        const newLeft = this.domLeft + offsetX
        const newTop = this.domTop + offsetY

        if (newLeft < 0) {
          dragDom.style.left = 0 + 'px'
        } else if (newLeft > pageWidth - dragWidth) {
          dragDom.style.left = pageWidth - dragWidth + 'px'
        } else {
          dragDom.style.left = newLeft + 'px'
        }
        if (newTop < this.topPosition) {
          dragDom.style.top = this.topPosition + 'px'
        } else if (newTop > pageHeight - dragHeight) {
          dragDom.style.top = pageHeight - dragHeight + 'px'
        } else {
          dragDom.style.top = newTop + 'px'
        }
      }
    })
    dragDom.addEventListener('touchend', () => {
      this.isDragged = false
      dragDom.style.left = `${pageWidth - dragDom.clientWidth}px`
      sessionStorage.setItem(
        'dragPosition',
        JSON.stringify({
          top: dragDom.style.top
        })
      )
    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-drag {
  width: fit-content;
  height: 100px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  transition: transform 0.2s;
  display: flex;
  align-items: center;
  /deep/.skc-lottie {
    width: 89px;
    height: 100px;
    position: absolute;
    left: -35px;
    top:0;
    z-index: 1;
  }

  .title {
    padding-right: 10px;
    width: 180px;
    height: 64px;
    background: linear-gradient(90deg, #ffa751 0%, #ff6400 100%);
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    right: 0;
    line-height: 64px;
    text-align: center;
    top:19px;
    padding-left: 51px;
    word-break: keep-all;
  }
}
</style>